<div [ngClass]="{ 'flex-grow-1': (state.items$ | async)?.length === 0 }" class="table-wrapper">
  <app-data-grid
    (loadMoreClicked)="onLoadMoreClicked()"
    (sortUpdated)="onSortUpdated($event)"
    [columns]="(state.columns$ | async) ?? []"
    [data]="(state.items$ | async) ?? []"
    [isLoading]="(state.isPending$ | async) ?? false"
    [isLoadingMore]="(state.isLoadingNextPage$ | async) ?? false"
    [noDataDescription]="
      (model.isSearchOrFilterApplied ? 'search.no-data-description' : '') | translate
    "
    [noDataIconTemplate]="
      model.isSearchOrFilterApplied ? gridEmptySearchIconTmpl : gridEmptyStateIconTmpl
    "
    [noDataTitle]="
      (model.isSearchOrFilterApplied
        ? 'search.no-data-title'
        : 'ti-admin.accounts.grid.no-data-title'
      ) | translate
    "
    [paginationEnabled]="(state.canLoadNextPage$ | async) ?? false"
    [sortOrder]="(state.gridSortOrder$ | async) || undefined"
    [templates]="{ name, billingStartDate, billingMode, isActive, loginAs }"
    [timezone]="'UTC'"
  ></app-data-grid>
</div>

<ng-template #gridEmptySearchIconTmpl>
  <app-icon-no-search></app-icon-no-search>
</ng-template>

<ng-template #gridEmptyStateIconTmpl>
  <app-icon-file-search></app-icon-file-search>
</ng-template>

<ng-template #name let-row="row">
  <div (click)="edit.emit(row)" class="account-name flex text-14">
    <app-icon-fleet [height]="40" [width]="40"></app-icon-fleet>
    <section class="account-info-container flex flex--col">
      <div class="account-name">
        {{ row.name }}
        @if (!row.isActive) {
          <p-tag
            [rounded]="true"
            [value]="'ti-admin.accounts.grid.suspended' | translate"
            class="alert fw-600 p-2-6"
          >
          </p-tag>
        }
        @if (row.isDemo) {
          <p-tag [rounded]="true" [value]="'Demo'" class="warning fw-600 p-2-6"></p-tag>
        }
      </div>

      <span class="account-email">{{ row.email }}</span>
    </section>
  </div>
</ng-template>

<ng-template #billingStartDate let-row="row">
  <span class="color-gray-900 text-14">
    @if (row.isDemo) {
      {{ 'ti-admin.accounts.grid.demo-account' | translate }}
    } @else {
      {{ 'ti-admin.accounts.grid.commercial-account' | translate }}
    }
  </span>
</ng-template>

<ng-template #billingMode let-row="row">
  <span class="color-gray-900 text-14">
    {{ 'ti-admin.accounts.grid.billing-' + row.billingMode | translate }}
  </span>
</ng-template>

<ng-template #isActive let-row="row">
  <app-yes-badge [color]="'var(--color-alert-500)'" [value]="!row.isActive"></app-yes-badge>
</ng-template>

<ng-template #loginAs let-data="row">
  <div class="activity-section flex">
    <p-button
      (onClick)="userManager.loginAsTspUser(data.owner)"
      [appCheckAccess]="[Resource.TSPUser, Action.LoginAs]"
      [disabled]="!data?.owner?.isActive || !data?.owner?.inviteAcceptedAt"
      [severity]="'secondary'"
      class="h--40 p--18 text-14 fw-600"
    >
      {{ 'users.grid.login-as-btn' | translate }}
    </p-button>
  </div>
</ng-template>
